
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { select } from '@ptl/angular-redux-store';
import { Observable } from 'rxjs';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';

@Component({
    selector: 'app-product-type-banner',
    templateUrl: './product-type-banner.component.html',
    styleUrls: ['./product-type-banner.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ProductTypeBannerComponent implements OnInit {

    @select(['componentStates', 'Plans', 'activeProductGroup']) productTab$: Observable<PRODUCT_GROUPS>;
    productTab: PRODUCT_GROUPS;

    productGroups = PRODUCT_GROUPS;
    isAuthoring = false;

    constructor(
        private authoringMode: AuthoringModeService
    ) { }

    ngOnInit() {
        this.isAuthoring = this.authoringMode.getAuthoringMode();
        this.productTab$.subscribe((tab: PRODUCT_GROUPS) => {
            this.productTab = tab;
        });
    }

}
